import { render, staticRenderFns } from "./RelCelula.vue?vue&type=template&id=7695c51b"
import script from "./RelCelula.vue?vue&type=script&lang=js"
export * from "./RelCelula.vue?vue&type=script&lang=js"
import style0 from "./RelCelula.vue?vue&type=style&index=0&id=7695c51b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports